<template>
  <div class="wt-transcribe-animation">
    <i class="wticon wticon-add-text" />
  </div>
</template>

<script>
export default {
  name: 'TranscribeAnimation',
};
</script>

<style lang="scss" scoped>
.wt-transcribe-animation {
  $round: 19px;
  width: $round;
  height: $round;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid $color-normal;
  border-radius: 50%;
  background: linear-gradient(0deg, rgb(255, 48, 102) 50%, white 50%);
  background-size: 200% 200%;
  animation: fillup 1.5s cubic-bezier(0, 0.3, 1, 0.7) infinite;

  @keyframes fillup {
    0% {
      background-position: 0% 0%;
    }
    80% {
      background-position: 100% 100%;
    }
    99% {
      background-position: 100% 100%;
    }
    100% {
      background-position: 0% 0%;
    }
  }

  .wticon {
    font-size: 9px;
    transform: translate(0, 1px);
  }
}
</style>
